/** Default when review has no stored country_code (matches existing reviews UI). */
export const REVIEW_DEFAULT_COUNTRY_NAME = 'United States';

/** Dial code → country name (from react-phone-input-2 country list). */
const DIAL_CODE_TO_COUNTRY: Record<string, string> = {
  '20': 'Egypt',
  '27': 'South Africa',
  '30': 'Greece',
  '36': 'Hungary',
  '40': 'Romania',
  '43': 'Austria',
  '51': 'Peru',
  '53': 'Cuba',
  '56': 'Chile',
  '58': 'Venezuela',
  '62': 'Indonesia',
  '66': 'Thailand',
  '84': 'Vietnam',
  '93': 'Afghanistan',
  '94': 'Sri Lanka',
  '95': 'Myanmar',
  '211': 'South Sudan',
  '212': 'Morocco',
  '213': 'Algeria',
  '216': 'Tunisia',
  '218': 'Libya',
  '220': 'Gambia',
  '221': 'Senegal',
  '222': 'Mauritania',
  '223': 'Mali',
  '224': 'Guinea',
  '226': 'Burkina Faso',
  '227': 'Niger',
  '228': 'Togo',
  '229': 'Benin',
  '230': 'Mauritius',
  '231': 'Liberia',
  '232': 'Sierra Leone',
  '233': 'Ghana',
  '234': 'Nigeria',
  '235': 'Chad',
  '236': 'Central African Republic',
  '237': 'Cameroon',
  '238': 'Cape Verde',
  '239': 'São Tomé and Príncipe',
  '240': 'Equatorial Guinea',
  '241': 'Gabon',
  '242': 'Congo',
  '243': 'Congo',
  '244': 'Angola',
  '245': 'Guinea-Bissau',
  '246': 'British Indian Ocean Territory',
  '248': 'Seychelles',
  '249': 'Sudan',
  '250': 'Rwanda',
  '251': 'Ethiopia',
  '252': 'Somalia',
  '253': 'Djibouti',
  '254': 'Kenya',
  '255': 'Tanzania',
  '256': 'Uganda',
  '257': 'Burundi',
  '258': 'Mozambique',
  '260': 'Zambia',
  '261': 'Madagascar',
  '262': 'Réunion',
  '263': 'Zimbabwe',
  '264': 'Namibia',
  '265': 'Malawi',
  '266': 'Lesotho',
  '267': 'Botswana',
  '268': 'Swaziland',
  '269': 'Comoros',
  '290': 'Saint Helena',
  '291': 'Eritrea',
  '297': 'Aruba',
  '298': 'Faroe Islands',
  '299': 'Greenland',
  '350': 'Gibraltar',
  '351': 'Portugal',
  '352': 'Luxembourg',
  '355': 'Albania',
  '356': 'Malta',
  '359': 'Bulgaria',
  '370': 'Lithuania',
  '376': 'Andorra',
  '377': 'Monaco',
  '378': 'San Marino',
  '381': 'Serbia',
  '382': 'Montenegro',
  '383': 'Kosovo',
  '385': 'Croatia',
  '386': 'Slovenia',
  '387': 'Bosnia and Herzegovina',
  '389': 'Macedonia',
  '421': 'Slovakia',
  '423': 'Liechtenstein',
  '500': 'Falkland Islands',
  '501': 'Belize',
  '504': 'Honduras',
  '505': 'Nicaragua',
  '507': 'Panama',
  '508': 'Saint Pierre and Miquelon',
  '591': 'Bolivia',
  '592': 'Guyana',
  '593': 'Ecuador',
  '594': 'French Guiana',
  '595': 'Paraguay',
  '596': 'Martinique',
  '597': 'Suriname',
  '598': 'Uruguay',
  '670': 'Timor-Leste',
  '672': 'Norfolk Island',
  '673': 'Brunei',
  '674': 'Nauru',
  '675': 'Papua New Guinea',
  '676': 'Tonga',
  '677': 'Solomon Islands',
  '678': 'Vanuatu',
  '679': 'Fiji',
  '680': 'Palau',
  '681': 'Wallis and Futuna',
  '682': 'Cook Islands',
  '683': 'Niue',
  '685': 'Samoa',
  '686': 'Kiribati',
  '687': 'New Caledonia',
  '688': 'Tuvalu',
  '689': 'French Polynesia',
  '690': 'Tokelau',
  '691': 'Micronesia',
  '692': 'Marshall Islands',
  '850': 'North Korea',
  '853': 'Macau',
  '855': 'Cambodia',
  '856': 'Laos',
  '880': 'Bangladesh',
  '886': 'Taiwan',
  '960': 'Maldives',
  '961': 'Lebanon',
  '962': 'Jordan',
  '963': 'Syria',
  '964': 'Iraq',
  '965': 'Kuwait',
  '966': 'Saudi Arabia',
  '967': 'Yemen',
  '968': 'Oman',
  '970': 'Palestine',
  '971': 'United Arab Emirates',
  '973': 'Bahrain',
  '974': 'Qatar',
  '975': 'Bhutan',
  '976': 'Mongolia',
  '977': 'Nepal',
  '992': 'Tajikistan',
  '993': 'Turkmenistan',
  '995': 'Georgia',
  '1242': 'Bahamas',
  '1246': 'Barbados',
  '1264': 'Anguilla',
  '1268': 'Antigua and Barbuda',
  '1284': 'British Virgin Islands',
  '1340': 'U.S. Virgin Islands',
  '1345': 'Cayman Islands',
  '1441': 'Bermuda',
  '1473': 'Grenada',
  '1649': 'Turks and Caicos Islands',
  '1664': 'Montserrat',
  '1670': 'Northern Mariana Islands',
  '1671': 'Guam',
  '1684': 'American Samoa',
  '1721': 'Sint Maarten',
  '1758': 'Saint Lucia',
  '1767': 'Dominica',
  '1784': 'Saint Vincent and the Grenadines',
  '1868': 'Trinidad and Tobago',
  '1869': 'Saint Kitts and Nevis',
  '1876': 'Jamaica',
};

/** Dial digits only (strips leading +). Accepts +1 or 1 from DB/API. */
export function dialDigitsFromCountryCode(raw: unknown): string | null {
  if (raw == null) return null;
  const digits = String(raw).trim().replace(/^\+/, '').replace(/\D/g, '');
  return digits || null;
}

/** Payload/DB format: always with + prefix (e.g. +1, +91). */
export function normalizeReviewCountryCode(raw: unknown): string | null {
  const digits = dialDigitsFromCountryCode(raw);
  if (!digits) return null;
  return `+${digits.slice(0, 9)}`;
}

export function countryNameFromDialCode(
  countryCode: unknown,
  fallback = REVIEW_DEFAULT_COUNTRY_NAME,
): string {
  const digits = dialDigitsFromCountryCode(countryCode);
  if (!digits) return fallback;
  return DIAL_CODE_TO_COUNTRY[digits] ?? fallback;
}

export function countryNameFromIsoCode(iso: unknown): string | null {
  const code = String(iso ?? '').trim().toUpperCase();
  if (!/^[A-Z]{2}$/.test(code)) return null;
  try {
    const display = new Intl.DisplayNames(['en'], { type: 'region' });
    const name = display.of(code);
    return name && name !== code ? name : null;
  } catch {
    return null;
  }
}

/** Resolve label for customer reviews from testimonial_trans.country_code only. */
export function countryNameForReview(countryCode: unknown): string {
  const raw = String(countryCode ?? '').trim();
  if (!raw) return REVIEW_DEFAULT_COUNTRY_NAME;

  const isoName = countryNameFromIsoCode(raw);
  if (isoName) return isoName;

  return countryNameFromDialCode(raw, REVIEW_DEFAULT_COUNTRY_NAME);
}
